var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgManageStripeIco(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 7.50196L18 2.50196M18 2.50196H13M18 2.50196L10.5 10.002M8.83333 2.50195H7C5.59987 2.50195 4.8998 2.50195 4.36502 2.77444C3.89462 3.01412 3.51217 3.39657 3.27248 3.86698C3 4.40176 3 5.10182 3 6.50195V13.502C3 14.9021 3 15.6022 3.27248 16.1369C3.51217 16.6073 3.89462 16.9898 4.36502 17.2295C4.8998 17.502 5.59987 17.502 7 17.502H14C15.4001 17.502 16.1002 17.502 16.635 17.2295C17.1054 16.9898 17.4878 16.6073 17.7275 16.1369C18 15.6022 18 14.9021 18 13.502V11.6686",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgManageStripeIco);
export default __webpack_public_path__ + "static/media/ManageStripeIco.27001b065bbcc41e6e55bc3a10bc1274.svg";
export { ForwardRef as ReactComponent };